import React from 'react';

type Report = {
    class: number;
    description: string;
    count: number;
    unit: string;   // e.g. "100.00 €"
    total: string;  // e.g. "100.00 €"
};


type TableRow = {
    clubCountryNumber: number | string;
    title: string;
    bic: string;
    iban: string;
    reports: Report[];
    total: number | string;
};

type Props = {
    rows: TableRow[];
};

const OldTable: React.FC<Props> = ({ rows }) => {
    const CLASS_NUMBERS = React.useMemo(() => Array.from({ length: 20 }, (_, i) => i + 1), []);

    const parseCurrencyToNumberString = (value?: string): string => {
        if (!value) return '0.00';
        // Remove currency symbols and spaces, normalize thousand/decimal separators
        const normalized = value
            .toString()
            .replace(/[^\d,.\-]/g, '') // keep digits, comma, dot, minus
            .replace(/\./g, '')        // remove thousand separators like 1.600,00
            .replace(',', '.');        // convert decimal comma to dot
        const num = Number(normalized);
        if (!Number.isFinite(num)) return '0.00';
        return num.toFixed(2);
    };

    // Compute unit price per class (1..20) from provided rows; default to 0.00
    const headerPrices: string[] = React.useMemo(() => {
        const allReports: Report[] = (rows || []).flatMap((r) => r.reports || []);
        return CLASS_NUMBERS.map((cls) => {
            const found = allReports.find((rep) => rep.class === cls);
            return found ? parseCurrencyToNumberString(found.unit) : '0.00';
        });
    }, [rows, CLASS_NUMBERS]);

    return (
        <table
            style={{ marginTop: 30 }}
            className="paymentlist-top content dtaus-col-hover w-full table-fixed text-[11px] border-collapse tracking-tight [&_td]:px-1 [&_td]:py-0.5 [&_td]:align-middle [&_td]:border [&_td]:border-gray-200 [&_td]:break-words [&_tr.center>td]:text-center [&_.money]:text-right [&_.money]:font-mono [&_tr.center>td]:w-8 [&_tbody>tr.center>td:nth-child(-n+20)]:bg-gray-100"
        >
            <thead className="dtaus-head sticky top-16 z-20 shadow-sm">
                <tr className="table-header">
                    <td colSpan={2}>
                        Clubnr.
                    </td>
                    <td colSpan={4}>Clubname</td>
                    <td colSpan={4}>BIC</td>
                    <td colSpan={5}>IBAN</td>
                    <td colSpan={5}>Betrag</td>
                    <td colSpan={3}>&nbsp;</td>
                </tr>
                <tr className="center" id="header-row">
                    {CLASS_NUMBERS.map((n) => (
                        <td key={`hdr-${n}`}>{n}</td>
                    ))}
                    <td colSpan={3}>&nbsp;</td>
                </tr>
                <tr className="center" id="header-price">
                    {headerPrices.map((p, idx) => (
                        <td key={`price-${idx + 1}`}>{p}</td>
                    ))}
                    <td colSpan={3}>&nbsp;</td>
                </tr>
            </thead>
            <tbody className="[&_tr:nth-child(even)]:bg-gray-50">
                {(rows as TableRow[]).map((item) => (
                    <>
                        <tr key={item.clubCountryNumber}>
                            <td className="sticky left-0 z-10 bg-white" colSpan={2}>
                                {item.clubCountryNumber}
                            </td>
                            <td colSpan={5} className="font-medium">{item.title}</td>
                            <td colSpan={3}>{item.bic}</td>
                            <td colSpan={5}>{item.iban}</td>
                        </tr>
                        <tr className="center" id="row-price">
                            {CLASS_NUMBERS.map((cls) => {
                                const rep = (item.reports || []).find((r) => r.class === cls);
                                return (
                                    <td
                                        key={`row-${item.clubCountryNumber}-${cls}`}
                                        className={rep ? '!bg-green-100' : '!bg-gray-100'}
                                    >
                                        {rep ? rep.count : '0'}
                                    </td>
                                );
                            })}
                            <td className="money"></td>
                            <td className="money" colSpan={2}>
                                {typeof item.total === 'string' ? item.total : `${item.total} €`}
                            </td>
                        </tr>
                    </>

                ))}
            </tbody>
        </table>
    );
};

export default OldTable;


